import ApiOptions from '@/datatypes/api-options';

export default class ApiPostOptions extends ApiOptions {
  constructor(options) {
    super(options);

    this.method = 'post';
  }
}
